import { HStack, VStack } from '@genial/components';
import { BoxRadius, Spacing, Color, Typography } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { Box, Skeleton } from 'native-base';

export const StructuredOperationDetailsLoading = () => {
  const isMobile = useBreakpointValue({ base: true, sm: false });

  const horizontalListSkeleton = useBreakpointValue({
    base: (
      <VStack space={Spacing['inline.xxxs']}>
        <HStack alignItems={'center'} space={Spacing['inline.nano']}>
          <HStack
            flex={1}
            alignItems={'center'}
            space={Spacing['inline.nano']}
            justifyContent={'space-between'}>
            <VStack flex={1}>
              <VStack maxW={'50px'} space={Spacing['inline.quarck']}>
                <Skeleton
                  w={'full'}
                  h={Typography['fontsize.md']}
                  borderRadius={BoxRadius.sm}
                  endColor={Color['brand.primary.lightest']}
                />
                <Skeleton
                  w={'full'}
                  h={Typography['fontsize.md']}
                  borderRadius={BoxRadius.sm}
                  endColor={Color['brand.primary.lightest']}
                />
              </VStack>
            </VStack>
            <VStack flex={1}>
              <VStack space={Spacing['inline.quarck']} maxW={'74px'}>
                <Skeleton
                  w={'full'}
                  h={Typography['fontsize.md']}
                  borderRadius={BoxRadius.sm}
                  endColor={Color['brand.primary.lightest']}
                />

                <Skeleton
                  w={'full'}
                  h={Typography['fontsize.md']}
                  borderRadius={BoxRadius.sm}
                  endColor={Color['brand.primary.lightest']}
                />
              </VStack>
            </VStack>
          </HStack>
        </HStack>
        <HStack alignItems={'center'} space={Spacing['inline.nano']}>
          <HStack
            flex={1}
            alignItems={'center'}
            space={Spacing['inline.nano']}
            justifyContent={'space-between'}>
            <VStack flex={1}>
              <VStack space={Spacing['inline.quarck']} maxW={'70px'}>
                <Skeleton
                  w={'full'}
                  h={Typography['fontsize.md']}
                  borderRadius={BoxRadius.sm}
                  endColor={Color['brand.primary.lightest']}
                />
                <Skeleton
                  w={'1/2'}
                  h={Typography['fontsize.md']}
                  borderRadius={BoxRadius.sm}
                  endColor={Color['brand.primary.lightest']}
                />
              </VStack>
            </VStack>
            <VStack flex={1}>
              <VStack space={Spacing['inline.quarck']} maxW={'70px'}>
                <Skeleton
                  w={'full'}
                  h={Typography['fontsize.md']}
                  borderRadius={BoxRadius.sm}
                  endColor={Color['brand.primary.lightest']}
                />

                <Skeleton
                  w={'full'}
                  h={Typography['fontsize.md']}
                  borderRadius={BoxRadius.sm}
                  endColor={Color['brand.primary.lightest']}
                />
              </VStack>
            </VStack>
          </HStack>
        </HStack>
        <HStack alignItems={'center'} space={Spacing['inline.nano']}>
          <HStack
            flex={1}
            alignItems={'center'}
            space={Spacing['inline.nano']}
            justifyContent={'space-between'}>
            <VStack flex={1}>
              <VStack space={Spacing['inline.quarck']} maxW={'92px'}>
                <Skeleton
                  w={'1/2'}
                  h={Typography['fontsize.md']}
                  borderRadius={BoxRadius.sm}
                  endColor={Color['brand.primary.lightest']}
                />
                <HStack alignItems={'center'} space={Spacing['inline.quarck']}>
                  {Array.from({ length: 5 }).map((_, index) => (
                    <Skeleton
                      key={index.toString()}
                      w={Spacing['inline.xxxs']}
                      h={Spacing['inline.xxxs']}
                      borderRadius={'full'}
                      endColor={Color['brand.primary.lightest']}
                    />
                  ))}
                </HStack>
              </VStack>
            </VStack>
            <VStack flex={1}>
              <VStack space={Spacing['inline.quarck']} maxW={'140px'}>
                <Skeleton
                  w={'full'}
                  h={Typography['fontsize.md']}
                  borderRadius={BoxRadius.sm}
                  endColor={Color['brand.primary.lightest']}
                />
                <Skeleton
                  w={'3/4'}
                  h={Typography['fontsize.md']}
                  borderRadius={BoxRadius.sm}
                  endColor={Color['brand.primary.lightest']}
                />
              </VStack>
            </VStack>
          </HStack>
        </HStack>
      </VStack>
    ),
    sm: (
      <VStack space={Spacing['inline.xxxs']}>
        <HStack alignItems={'center'} space={Spacing['inline.nano']}>
          <HStack
            flex={1}
            alignItems={'center'}
            space={Spacing['inline.nano']}
            justifyContent={'space-between'}>
            <VStack flex={1}>
              <VStack maxW={'50px'} space={Spacing['inline.quarck']}>
                <Skeleton
                  w={'full'}
                  h={Typography['fontsize.md']}
                  borderRadius={BoxRadius.sm}
                  endColor={Color['brand.primary.lightest']}
                />
                <Skeleton
                  w={'full'}
                  h={Typography['fontsize.md']}
                  borderRadius={BoxRadius.sm}
                  endColor={Color['brand.primary.lightest']}
                />
              </VStack>
            </VStack>
            <VStack flex={1}>
              <VStack space={Spacing['inline.quarck']} maxW={'74px'}>
                <Skeleton
                  w={'full'}
                  h={Typography['fontsize.md']}
                  borderRadius={BoxRadius.sm}
                  endColor={Color['brand.primary.lightest']}
                />

                <Skeleton
                  w={'full'}
                  h={Typography['fontsize.md']}
                  borderRadius={BoxRadius.sm}
                  endColor={Color['brand.primary.lightest']}
                />
              </VStack>
            </VStack>
            <VStack flex={1}>
              <VStack space={Spacing['inline.quarck']} maxW={'70px'}>
                <Skeleton
                  w={'full'}
                  h={Typography['fontsize.md']}
                  borderRadius={BoxRadius.sm}
                  endColor={Color['brand.primary.lightest']}
                />
                <Skeleton
                  w={'1/2'}
                  h={Typography['fontsize.md']}
                  borderRadius={BoxRadius.sm}
                  endColor={Color['brand.primary.lightest']}
                />
              </VStack>
            </VStack>
          </HStack>
        </HStack>
        <HStack alignItems={'center'} space={Spacing['inline.nano']}>
          <HStack
            flex={1}
            alignItems={'center'}
            space={Spacing['inline.nano']}
            justifyContent={'space-between'}>
            <VStack flex={1}>
              <VStack space={Spacing['inline.quarck']} maxW={'70px'}>
                <Skeleton
                  w={'full'}
                  h={Typography['fontsize.md']}
                  borderRadius={BoxRadius.sm}
                  endColor={Color['brand.primary.lightest']}
                />

                <Skeleton
                  w={'full'}
                  h={Typography['fontsize.md']}
                  borderRadius={BoxRadius.sm}
                  endColor={Color['brand.primary.lightest']}
                />
              </VStack>
            </VStack>
            <VStack flex={1}>
              <VStack space={Spacing['inline.quarck']} maxW={'92px'}>
                <Skeleton
                  w={'1/2'}
                  h={Typography['fontsize.md']}
                  borderRadius={BoxRadius.sm}
                  endColor={Color['brand.primary.lightest']}
                />
                <HStack alignItems={'center'} space={Spacing['inline.quarck']}>
                  {Array.from({ length: 5 }).map((_, index) => (
                    <Skeleton
                      key={index.toString()}
                      w={Spacing['inline.xxxs']}
                      h={Spacing['inline.xxxs']}
                      borderRadius={'full'}
                      endColor={Color['brand.primary.lightest']}
                    />
                  ))}
                </HStack>
              </VStack>
            </VStack>
            <VStack flex={1}>
              <VStack space={Spacing['inline.quarck']} maxW={'140px'}>
                <Skeleton
                  w={'full'}
                  h={Typography['fontsize.md']}
                  borderRadius={BoxRadius.sm}
                  endColor={Color['brand.primary.lightest']}
                />
                <Skeleton
                  w={'3/4'}
                  h={Typography['fontsize.md']}
                  borderRadius={BoxRadius.sm}
                  endColor={Color['brand.primary.lightest']}
                />
              </VStack>
            </VStack>
          </HStack>
        </HStack>
      </VStack>
    ),
  });

  return (
    <VStack
      w={{ base: 'full', lg: '910px' }}
      bg="neutral.white"
      borderRadius={BoxRadius.sm}
      space={{ base: Spacing['inline.xxxs'], sm: 0 }}>
      <Box
        w={{ base: Spacing['inline.md'], lg: 0 }}
        background={'neutral.lightest'}
        borderRadius={BoxRadius.sm}
        h={{ base: 1, lg: 0 }}
        alignSelf={'center'}
        mt={Spacing['inline.xxxs']}
      />
      <VStack
        space={Spacing['inline.xxxs']}
        p={{ base: Spacing['inset.xs'], sm: Spacing['inset.md'] }}>
        <HStack justifyContent={'space-between'} alignItems={'flex-start'}>
          <VStack space={Spacing['inline.quarck']} flex={1}>
            {!isMobile && (
              <Skeleton
                width={'2/4'}
                height={Typography['fontsize.md']}
                borderRadius={'full'}
                endColor={Color['brand.primary.lightest']}
              />
            )}
            <Skeleton
              width={'2/4'}
              height={Typography['fontsize.xxl']}
              borderRadius={'full'}
              endColor={Color['brand.primary.lightest']}
            />
          </VStack>
          {!isMobile && (
            <Skeleton
              width={Spacing['inline.xxs']}
              height={Spacing['inline.xxs']}
              borderRadius={'full'}
              endColor={Color['brand.primary.lightest']}
            />
          )}
        </HStack>
        {!isMobile && <Box w={'full'} bg={'neutral.lightest'} h={'0.5'} />}
        <Skeleton
          width={'2/5'}
          height={Typography['fontsize.md']}
          borderRadius={'full'}
          endColor={Color['brand.primary.lightest']}
        />
        <Skeleton.Text
          width={'full'}
          lines={2}
          borderRadius={'full'}
          endColor={Color['brand.primary.lightest']}
        />
        {horizontalListSkeleton}
        <Box w={'full'} bg="neutral.white" h={'0.5'} />
        {Array.from({ length: 4 }).map((_, index) => (
          <Skeleton
            key={index.toString()}
            width={'full'}
            height={Spacing['stack.lg']}
            borderRadius={'md'}
            endColor={Color['brand.primary.lightest']}
          />
        ))}
      </VStack>
    </VStack>
  );
};
